var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tree",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4779",
    "data-name": "Ellipse 4779",
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#f1f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-139.624 19.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87721",
    "data-name": "Path 87721",
    d: "M171.9,3.354a4.511,4.511,0,0,1,1.065.75,4.813,4.813,0,0,1,9.53.059,4.819,4.819,0,0,1,5.229,5.821,3.125,3.125,0,0,1-.178.612,4.823,4.823,0,0,1-2.111,9.155c-.769,0-1.5,0-2.21-.02-.474.178-3.749,1.381-4.558,4.538a.4.4,0,0,1-.079.158v8.859h5.84a.395.395,0,1,1,0,.789H169.452a.395.395,0,1,1,0-.789h5.209V24.249a.4.4,0,0,1-.079-.158c-.809-3.157-4.1-4.38-4.558-4.518-.73-.02-1.46-.02-2.21-.02A4.823,4.823,0,0,1,165.7,10.4a6.9,6.9,0,0,1-.572-1.065A4.826,4.826,0,0,1,171.9,3.354Zm6.689,19.08a7.744,7.744,0,0,1,2.822-2.7c-.987-.02-1.914-.02-2.822-.039Zm-3.926-2.8c-.947-.02-1.855-.039-2.762-.039a7.8,7.8,0,0,1,2.762,2.664Z",
    fill: "#66939f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/Tree.df68c6000a2b35073fae7986e5fd9dfc.svg";
export { ForwardRef as ReactComponent };